export default {
	/** @zh 正式API，官网为 https://www.quxun.co */
	url: "https://apis.quxun.co/API",
	/** @zh 测试API ，官网按照 https://www.bonpont.com/ 进行升级 */
}



// WEBPACK FOOTER //
// ./src/assets/apiUrl.js